<template>
  <div class="insured_info_item_for_pc">
<!--    <van-cell>
      <div class="item_title_box">
        <div class="insured_index">{{ handleChinese() }}</div>
        <div class="handle_item" @click="delOne(index)">删除</div>
      </div>
    </van-cell> -->
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ handleChinese() }}
	</span>
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ insuredInfo.insuredName }}
	</span>
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ handleInsuredCertificatIdListChinese() }}
	</span>
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ insuredInfo.insuredIdCardNum }}
	</span>
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ insuredInfo.birthday }}
	</span>
	<span
	  class="my_insured_field"
	  name="insuredName"
	>
	{{ handleInsuredGenderListChinese() }}
	</span>
    <div class="my_insured_field aoperation"><a @click="editOne(index)" href="javascript:void(0);">编辑</a><a @click="delOne(index)" href="javascript:void(0);">删除</a></div>
  </div>
</template>

<script>
import './InsuredInfoPCItem.less';
import { SectionToChinese } from '../../utils/sectionToChinese'
import { Cell, Field, Picker, Popup, DatetimePicker } from 'vant';
import dayjs from '../../libs/js/day'
export default {
  name: 'InsuredInfoPCItem',
  data() {
    return {		
    }
  },
  props: {
    insuredInfo: Object,
    index: Number,
    delOne: Function,
	editOne: Function,
	insuredCertificatIdList:Array,
	genderList:Array
  },
  components: {
    'van-cell': Cell,
    'van-field': Field,
    'van-popup': Popup,
    'van-picker': Picker,
    'van-popup': Popup,
    'van-datetime-picker': DatetimePicker,
  },
  methods: {
	  verifyTypeSelected(event){
		  this.$emit("confirmInsuredCertificatId",{index:this.index,insuredCertificatId:this.insuredInfo.insuredCertificatId});
	  },
    onInsuredCertificatTypesConfirm(value) {
      this.insuredInfo.insuredCertificat = value.value
      this.insuredInfo.insuredCertificatId = value.id
      this.insuredInfo.showInsuredCertificatPicker = false
    },
    onInsuredCalendarConfirm(date) {
      this.insuredInfo.birthday = dayjs(date).format('YYYY-MM-DD')
      this.insuredInfo.showInsuredCalendar = false
    },
    formatterDate(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    handleChinese() {
      return `被保人${SectionToChinese(this.index + 1)}`
    },
	handleInsuredCertificatIdListChinese(){
		const data = this.insuredCertificatIdList.find(x=>x.value == this.insuredInfo.insuredCertificatId)
		return data?data.name:''
	},
	handleInsuredGenderListChinese(){
		const data = this.genderList.find(x=>x.value == this.insuredInfo.insuredGender)
		return data?data.name:''
	}
  }
}
</script>

<style>
	.aoperation{
		display: flex;
		justify-content: space-evenly;
	}
</style>